import React, { useState } from 'react';
import { 
    AcademicCapIcon, 
    InformationCircleIcon,
    UserIcon,
    ScaleIcon,
    ChevronDownIcon,
    ChevronUpIcon
} from '@heroicons/react/24/outline';

function SizeGuidePage() {
    const [activeCategory, setActiveCategory] = useState('bebek');
    const [expandedSection, setExpandedSection] = useState('olcum-rehberi');

    const sizeData = {
        bebek: {
            title: 'Bebek Giyim (0-24 Ay)',
            sizes: [
                { size: '0-3 Ay', boy: '50-62 cm', kilo: '3-6 kg', gogus: '40-44 cm' },
                { size: '3-6 Ay', boy: '62-68 cm', kilo: '6-8 kg', gogus: '44-48 cm' },
                { size: '6-9 Ay', boy: '68-74 cm', kilo: '8-10 kg', gogus: '48-52 cm' },
                { size: '9-12 Ay', boy: '74-80 cm', kilo: '10-12 kg', gogus: '52-56 cm' },
                { size: '12-18 Ay', boy: '80-86 cm', kilo: '12-14 kg', gogus: '56-60 cm' },
                { size: '18-24 Ay', boy: '86-92 cm', kilo: '14-16 kg', gogus: '60-64 cm' }
            ]
        },
        cocuk: {
            title: 'Çocuk Giyim (2-8 Yaş)',
            sizes: [
                { size: '2 Yaş', boy: '92-98 cm', kilo: '12-14 kg', gogus: '52-54 cm' },
                { size: '3 Yaş', boy: '98-104 cm', kilo: '14-16 kg', gogus: '54-56 cm' },
                { size: '4 Yaş', boy: '104-110 cm', kilo: '16-18 kg', gogus: '56-58 cm' },
                { size: '5 Yaş', boy: '110-116 cm', kilo: '18-20 kg', gogus: '58-60 cm' },
                { size: '6 Yaş', boy: '116-122 cm', kilo: '20-22 kg', gogus: '60-62 cm' },
                { size: '7 Yaş', boy: '122-128 cm', kilo: '22-25 kg', gogus: '62-64 cm' },
                { size: '8 Yaş', boy: '128-134 cm', kilo: '25-28 kg', gogus: '64-66 cm' }
            ]
        },
        buyuk: {
            title: 'Büyük Çocuk (9-14 Yaş)',
            sizes: [
                { size: '9 Yaş', boy: '134-140 cm', kilo: '28-32 kg', gogus: '66-70 cm' },
                { size: '10 Yaş', boy: '140-146 cm', kilo: '32-36 kg', gogus: '70-74 cm' },
                { size: '11 Yaş', boy: '146-152 cm', kilo: '36-40 kg', gogus: '74-78 cm' },
                { size: '12 Yaş', boy: '152-158 cm', kilo: '40-45 kg', gogus: '78-82 cm' },
                { size: '13 Yaş', boy: '158-164 cm', kilo: '45-50 kg', gogus: '82-86 cm' },
                { size: '14 Yaş', boy: '164-170 cm', kilo: '50-55 kg', gogus: '86-90 cm' }
            ]
        },
        ayakkabi: {
            title: 'Ayakkabı Beden Tablosu',
            sizes: [
                { size: '19', uzunluk: '11.5 cm', yas: '6-12 ay' },
                { size: '20', uzunluk: '12.0 cm', yas: '9-15 ay' },
                { size: '21', uzunluk: '12.5 cm', yas: '12-18 ay' },
                { size: '22', uzunluk: '13.0 cm', yas: '15-21 ay' },
                { size: '23', uzunluk: '13.5 cm', yas: '18-24 ay' },
                { size: '24', uzunluk: '14.0 cm', yas: '2-2.5 yaş' },
                { size: '25', uzunluk: '14.5 cm', yas: '2.5-3 yaş' },
                { size: '26', uzunluk: '15.0 cm', yas: '3-3.5 yaş' },
                { size: '27', uzunluk: '15.5 cm', yas: '3.5-4 yaş' },
                { size: '28', uzunluk: '16.0 cm', yas: '4-4.5 yaş' },
                { size: '29', uzunluk: '16.5 cm', yas: '4.5-5 yaş' },
                { size: '30', uzunluk: '17.0 cm', yas: '5-5.5 yaş' },
                { size: '31', uzunluk: '17.5 cm', yas: '5.5-6 yaş' },
                { size: '32', uzunluk: '18.0 cm', yas: '6-6.5 yaş' },
                { size: '33', uzunluk: '18.5 cm', yas: '6.5-7 yaş' },
                { size: '34', uzunluk: '19.0 cm', yas: '7-7.5 yaş' },
                { size: '35', uzunluk: '19.5 cm', yas: '7.5-8 yaş' }
            ]
        }
    };

    const measurementTips = [
        {
            title: 'Boy Ölçümü',
            description: 'Çocuğunuzu duvara yaslaştırarak, başının en üst noktasından ayak tabanına kadar ölçün.',
            icon: AcademicCapIcon
        },
        {
            title: 'Göğüs Ölçümü',
            description: 'Kolların altından geçirerek göğsün en geniş yerinden ölçün.',
            icon: ScaleIcon
        },
        {
            title: 'Ayak Ölçümü',
            description: 'Çocuğunuzun ayağını kağıda bastırarak en uzun parmaktan topuğa kadar ölçün.',
            icon: UserIcon
        }
    ];

    const toggleSection = (section) => {
        setExpandedSection(expandedSection === section ? null : section);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            {/* Hero Section */}
            <div className="bg-gradient-to-r from-brand-green to-brand-green-light text-white py-12 sm:py-16">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 flex items-center justify-center">
                        <AcademicCapIcon className="w-8 h-8 sm:w-10 sm:h-10 mr-3" />
                        Beden Rehberi
                    </h1>
                    <p className="text-lg sm:text-xl opacity-90 max-w-2xl mx-auto">
                        Çocuğunuz için doğru bedeni seçmek artık çok kolay! 
                        Detaylı beden tablolarımız ile mükemmel uyumu yakalayın.
                    </p>
                </div>
            </div>

            <div className="container mx-auto px-4 py-12">
                
                {/* Ölçüm Rehberi */}
                <div className="mb-8">
                    <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                        <button
                            onClick={() => toggleSection('olcum-rehberi')}
                            className="w-full px-6 py-4 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-bold text-lg flex items-center justify-between hover:from-blue-600 hover:to-blue-700 transition-all"
                        >
                            <span className="flex items-center">
                                <InformationCircleIcon className="w-6 h-6 mr-2" />
                                Nasıl Ölçüm Yapılır?
                            </span>
                            {expandedSection === 'olcum-rehberi' ? 
                                <ChevronUpIcon className="w-5 h-5" /> : 
                                <ChevronDownIcon className="w-5 h-5" />
                            }
                        </button>
                        
                        {expandedSection === 'olcum-rehberi' && (
                            <div className="p-6">
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                    {measurementTips.map((tip, index) => (
                                        <div key={index} className="text-center p-4 bg-gray-50 rounded-lg">
                                            <tip.icon className="w-12 h-12 text-brand-green mx-auto mb-3" />
                                            <h3 className="font-bold text-gray-800 mb-2">{tip.title}</h3>
                                            <p className="text-sm text-gray-600">{tip.description}</p>
                                        </div>
                                    ))}
                                </div>
                                
                                <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                                    <h4 className="font-bold text-yellow-800 mb-2">💡 Önemli Notlar:</h4>
                                    <ul className="text-sm text-yellow-700 space-y-1">
                                        <li>• Ölçümleri çocuğunuz ayakta dururken yapın</li>
                                        <li>• Ölçüm bandını çok sıkmayın, rahat olsun</li>
                                        <li>• İki beden arasında kalıyorsanız büyük bedeni tercih edin</li>
                                        <li>• Ayakkabı için akşam saatlerinde ölçüm yapın (ayak şişer)</li>
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Kategori Seçimi */}
                <div className="mb-8">
                    <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">Kategori Seçin</h2>
                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                            {Object.entries(sizeData).map(([key, data]) => (
                                <button
                                    key={key}
                                    onClick={() => setActiveCategory(key)}
                                    className={`p-4 rounded-lg border-2 transition-all duration-300 ${
                                        activeCategory === key
                                            ? 'border-brand-green bg-brand-green text-white shadow-lg transform scale-105'
                                            : 'border-gray-200 bg-white text-gray-700 hover:border-brand-green hover:shadow-md'
                                    }`}
                                >
                                    <div className="text-center">
                                        <div className="font-bold text-sm sm:text-base">{data.title}</div>
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Beden Tablosu */}
                <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                    <div className="bg-gradient-to-r from-brand-green to-brand-green-light text-white p-6">
                        <h2 className="text-2xl font-bold text-center">
                            {sizeData[activeCategory].title}
                        </h2>
                    </div>
                    
                    <div className="p-6">
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead>
                                    <tr className="border-b-2 border-gray-200">
                                        <th className="text-left py-3 px-4 font-bold text-gray-700">Beden</th>
                                        {activeCategory === 'ayakkabi' ? (
                                            <>
                                                <th className="text-left py-3 px-4 font-bold text-gray-700">Ayak Uzunluğu</th>
                                                <th className="text-left py-3 px-4 font-bold text-gray-700">Yaş Aralığı</th>
                                            </>
                                        ) : (
                                            <>
                                                <th className="text-left py-3 px-4 font-bold text-gray-700">Boy</th>
                                                <th className="text-left py-3 px-4 font-bold text-gray-700">Kilo</th>
                                                <th className="text-left py-3 px-4 font-bold text-gray-700">Göğüs</th>
                                            </>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {sizeData[activeCategory].sizes.map((item, index) => (
                                        <tr 
                                            key={index} 
                                            className={`border-b border-gray-100 hover:bg-gray-50 transition-colors ${
                                                index % 2 === 0 ? 'bg-white' : 'bg-gray-25'
                                            }`}
                                        >
                                            <td className="py-4 px-4 font-semibold text-brand-green">{item.size}</td>
                                            {activeCategory === 'ayakkabi' ? (
                                                <>
                                                    <td className="py-4 px-4 text-gray-700">{item.uzunluk}</td>
                                                    <td className="py-4 px-4 text-gray-700">{item.yas}</td>
                                                </>
                                            ) : (
                                                <>
                                                    <td className="py-4 px-4 text-gray-700">{item.boy}</td>
                                                    <td className="py-4 px-4 text-gray-700">{item.kilo}</td>
                                                    <td className="py-4 px-4 text-gray-700">{item.gogus}</td>
                                                </>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Yardımcı Bilgiler */}
                <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
                        <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                            <InformationCircleIcon className="w-6 h-6 text-brand-green mr-2" />
                            Beden Seçimi İpuçları
                        </h3>
                        <ul className="space-y-3 text-gray-600">
                            <li className="flex items-start">
                                <span className="text-brand-green mr-2">•</span>
                                <span>Çocuklar hızla büyüdüğü için biraz bol tercih edebilirsiniz</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-brand-green mr-2">•</span>
                                <span>Mevsimlik kıyafetlerde bir üst beden alabilirsiniz</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-brand-green mr-2">•</span>
                                <span>Elastik kumaşlar daha esnek beden seçimi sağlar</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-brand-green mr-2">•</span>
                                <span>Şüphe durumunda müşteri hizmetlerimizden destek alın</span>
                            </li>
                        </ul>
                    </div>

                    <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
                        <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                            <UserIcon className="w-6 h-6 text-brand-green mr-2" />
                            Yardıma İhtiyacınız mı Var?
                        </h3>
                        <p className="text-gray-600 mb-4">
                            Beden seçiminde kararsız mı kaldınız? Size yardımcı olmaktan mutluluk duyarız!
                        </p>
                        <div className="space-y-3">
                            <a 
                                href="/iletisim" 
                                className="block w-full bg-brand-green text-white text-center py-3 px-4 rounded-lg hover:bg-brand-green-light transition-colors"
                            >
                                Bize Ulaşın
                            </a>
                            <a 
                                href="tel:+905552609420" 
                                className="block w-full border-2 border-brand-green text-brand-green text-center py-3 px-4 rounded-lg hover:bg-brand-green hover:text-white transition-colors"
                            >
                                📞 Hemen Arayın
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SizeGuidePage;